export enum KeyCode {
    Escape = 27,
    Enter = 13
}
